import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { RadiosCustomElement, Highlight } from "cw-styleguide-react";

class Question extends Component {
  setAnswer(index, answer) {
    const answers = this.props.answers;
    
    answers[index] = answer;

    this.props.setAnswers(this.props.questionIndex, answers);
  }

  render() {
    return (
      <Fragment>
        <Highlight>
          <h2>{this.props.question.title}</h2>
          <h3>{this.props.question.subtitle}</h3>
          <p>{this.props.question.body}</p>
          {this.props.question.answers.map((answer, index) => {
            return (
              <RadiosCustomElement
                key={`${this.props.question.id}-${index}`}
                type={'a'}
                groupLabel={`${this.props.t('styleguide:choose')} ${answer[this.props.question.codes[0]]} ${this.props.t('styleguide:or')} ${answer[this.props.question.codes[1]]}`}
                name={`step${this.props.step}.q${index + 1}`}
                defaultChecked={this.props.answers[index]}
                onChange={(e) => this.setAnswer(index, e.target.value)}
                options={
                  [
                    {
                      'value': this.props.question.codes[0],
                      'label': answer[this.props.question.codes[0]]
                    },
                    {
                      'value': this.props.question.codes[1],
                      'label': answer[this.props.question.codes[1]]
                    }
                  ]
                }
              />
            );
          })}
        </Highlight>
      </Fragment>
    )
  }
}

export default withTranslation('local')(Question);
